module.exports = __webpack_public_path__ + "img/proceed-img.538fad0a.png";